module.exports = __webpack_public_path__ + "assets/img/icon (4).089fb97b.png";